import React, { useEffect, } from 'react'
import portada from './assets/img/portada.svg'
import './assets/styles.css'
import { Link } from 'react-router-dom'

function App() {
  useEffect( () => {
    localStorage.removeItem( 'popup' )
  }, [] )

  return (
    <div className="container-fluid">
        <div className="row">
            <img className="col-12 img-fluid px-0" alt="portada" src={portada} />
        </div>
        <div className="row">
            <div className="col-1 col-md-2 col-lg-4">
                <hr className='d-none d-lg-block' style={{width: "71px", border: "5px solid #70dace", borderRadius: "5px", marginRight: "40px", marginTop: "135px", textAlign: "right"}} />
            </div>

            <div className="col-10 col-md-8 col-lg-4">
                <h1>
                    Información de Interés
                </h1>
            </div>
            <div className="col-1 d-none d-lg-block"></div>
        </div>
        <div className="row justify-content-center">
            <div className='col-10 col-md-8 col-lg-4'>
                <div style={{textAlign: "justify"}}>
                    <span className="p" style={{fontSize: "0.938em"}}>
                        El propósito de esta encuesta es recoger la percepción e interés del vecino por los distintos tipos de problemas que pudiera tener el barrio. Con ello se pretende elaborar un diagnóstico socio físico que pueda servir a diferentes instituciones comunitarias del mismo para desarrollar acciones de mejoras urbanas legitimadas a partir de la opinión auténtica de los habitantes.<br/>
                        Se trata de un trabajo desarrollado por la Universidad Nacional del Litoral con fines académicos orientados a brindar un servicio a la comunidad.<br/>
                        La información que se recoge mediante esta encuesta es gestionada por la propia universidad.
                    </span>
                </div>
            </div>
        </div>
        <div className="row justify-content-center">
            <div className="col-md-12 mt-2" style={{textAlign: "center"}}>
                <Link to={"/step1"} className="button">COMENZAR</Link>
            </div>
        </div>
      </div>
  )
}

export default App;
